<!-- HEADER BOTONERA -->
<form [formGroup]='formData' (ngSubmit)="buscar(true)">
  <div class="card mt-2 mb-2 wow">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        display: flex;
        align-items: center;
      ">
        <h4>Buscar promociones</h4>
        <button type="button" mdbBtn color="info" (click)="abrirModalAgregarPromocion()" size="sm" mdbWavesEffect>
          Agregar
        </button>
      </div>

      <div class="filtros-body">
        <div class="row">
          <div class="col" style="
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 2%;
          ">
            <strong>Buscar por: </strong>
            <!-- Material inline 1 -->
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="tab_promociones_rbBuscarPor_cliente"
                formControlName="buscarPor" [value]="TIPO_TIPO_CLIENTE" mdbInput (change)='limpiarBuscarPorCliente()' />
              <label class="form-check-label" for="tab_promociones_rbBuscarPor_cliente">Tipo cliente</label>
            </div>

            <!-- Material inline 2 -->
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="tab_promociones_rbBuscarPor_tipo_cliente"
                formControlName="buscarPor" [value]="TIPO_CLIENTE" mdbInput
                (change)='limpiarBuscarPorTiposClientes()' />
              <label class="form-check-label" for="tab_promociones_rbBuscarPor_tipo_cliente">Cliente</label>
            </div>

            <div class="col" *ngIf="formData.get('buscarPor').value === TIPO_CLIENTE" style="max-width: 150px">
              <div class="md-form">
                <input value="" type="text" id="rutcliente" class="form-control" placeholder="" #rutcliente
                  formControlName="rutCliente" formatRut />
                <label for="rutcliente">RUT</label>
              </div>
            </div>

            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccion()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>

            <ng-container *ngIf="formData.get('buscarPor').value === TIPO_CLIENTE">
              <button mdbBtn type="button" class="" color="info" mdbWavesEffect
                (click)="abrirModalSeleccionarClienteSeleccionados()" *ngIf="clientesSeleccionados?.length > 0">
                ({{clientesSeleccionados.length | numerico}}) Seleccionados
              </button>
            </ng-container>
            <ng-container *ngIf="formData.get('buscarPor').value === TIPO_TIPO_CLIENTE">
              <button mdbBtn type="button" class="" color="info" mdbWavesEffect
                (click)="abrirModalSeleccionarTiposClienteSeleccionados()"
                *ngIf="tiposClientesSeleccionados?.length > 0">
                ({{tiposClientesSeleccionados.length | numerico}}) Seleccionados
              </button>
            </ng-container>

            <!-- <h6 class="text-info" *ngIf="clienteSeleccionado">
              {{ clienteSeleccionado.nombre }}
            </h6> -->
            <!-- <h6 class="text-info" *ngIf="clientesSeleccionados">
              {{ clientesSeleccionadosFormatted }}
            </h6> -->
            <!-- <h6 class="text-info" *ngIf="tiposClientesSeleccionados">
              {{ tiposClientesSeleccionadosFormatted }}
            </h6> -->
          </div>

          <div class="col">
            <div class="row">
              <div class="col-3">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha inicio'" required
                    formControlName='fechaInicio'>
                  </mdb-date-picker>
                </div>
              </div>

              <div class="col-3">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaFinal" [placeholder]="'Fecha final'" required
                    formControlName='fechaFin'>
                  </mdb-date-picker>
                </div>
              </div>

              <div class="col" style="
              font-size: 14px;
              font-weight: bold;
              padding-top:1%">
               <span>Estados:</span>
               <div class="form-check">
                 <input class="form-check-input" type="radio" mdbInput id="EstActivoProm" [value]="RO_EstadoActivoProm" formControlName="estadoActProm" checked>
                 <label class="form-check-label" for="EstActivoProm">
                   Activo
                 </label>
               </div>
               <div class="form-check">
                 <input class="form-check-input" type="radio" mdbInput id="EstInactivoProm" [value]="RO_EstadoInactivoProm" formControlName="estadoActProm">
                 <label class="form-check-label" for="EstInactivoProm">
                   Inactivo
                 </label>
               </div>
             </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="submit" size="sm" color="secondary" mdbWavesEffect>
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- LISTADO -->
<div class="card mb-2 wow">
  <div class="card-body" *ngIf="listaPromociones">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <!-- <th scope="col">Código</th> -->
          <th scope="col">Desde</th>
          <th scope="col">Hasta</th>
          <th scope="col">Estado</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="100%" style="text-align: center">
            <mdb-spinner spinnerColor="blue"></mdb-spinner>
          </td>
        </tr>
        <tr *ngIf="!loading && listaPromociones?.length === 0">
          <td colspan="100%" style="text-align: center">
            No se encontró información
          </td>
        </tr>
        <tr *ngFor="let promocion of listaPromociones; trackBy: trackByPromocionCodigo">
          <!-- <td>{{ promocion.codigo }}</td> -->
          <td>{{ promocion.fecha_inicio | fecha }}</td>
          <td>{{ promocion.fecha_termino | fecha }}</td>
          <td>
            <mdb-badge pill="true" success="true" *ngIf='promocion.activo'>Activo</mdb-badge>
            <mdb-badge pill="true" danger="true" *ngIf='!promocion.activo'>Inactivo</mdb-badge>
          </td>
          <td>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" mdbTooltip="Ver"
              placement="right" (click)="ver(promocion)">
              <mdb-icon fas icon="eye"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              (click)="editar(promocion)" mdbTooltip="Editar" placement="right" [disabled]="!promocion.permiteEdicion || !promocion.activo">
              <!-- [ngClass]="{'v-hidden': !promocion.permiteEdicion, 'v-visible': promocion.permiteEdicion}" -->
              <mdb-icon fas icon="pen"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Desactivar" placement="right" (click)="confirmDesactivar(promocion.codigo)"
              [disabled]="!promocion.permiteEdicion || !promocion.activo">
              <mdb-icon fas icon="ban"></mdb-icon>
            </button>
          </td>
        </tr>
      </tbody>
      <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
        *ngIf="listaPromociones?.length > 0"></app-pagination>
    </table>
  </div>
</div>


<!-- MODAL Agregar Promocion -->
<app-modal-addedit-promocion [permiteUnidadNegocio]="permiteUnidadNegocio"
  [optionsUnidadesDeNegocio]="optionsUnidadesDeNegocio" [optionsTipoDescuento]='optionsTipoDescuento'
  (onSuccess)="onPromocionSaved()">
</app-modal-addedit-promocion>


<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)" queryType="ONLY_RUT"
  (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>
<app-modal-seleccionar-cliente-tipos (onSelectMultiple)="onClienteTiposSeleccionado($event)">
</app-modal-seleccionar-cliente-tipos>


<app-modal-confirm title="Desactivar promoción" contentText="¿Desea desactivar la promoción?">
</app-modal-confirm>

<app-modal-show-clientes>
</app-modal-show-clientes>
